export default __webpack_public_path__ + "assets/media/new.da4256ef.png";